<template>
    <div id="chapter" :class="bg" ref="chapter">
        <div class="head-tool">
            <span class="title">{{curr.title}}</span>

            <router-link tag="span" :to="{name:'Book',params:{wid:bookid}}" class="fr">书简介</router-link>
            <router-link tag="span" class="fr" to="/">首页</router-link>
            <span class="fr tousu-btn" @click="tousu = 1"><i class="iconfont icon-tousu"></i> 投诉</span>
        </div>
        <div class="info" @click="hidetool = !hidetool">
            <div class="tool" @click.stop>
                <div class="fl">
                    <span class="bg1" :class="{active:bg == 'default'}" @click="setTheme('default')"></span>
                    <span class="bg2" :class="{active:bg == 'pink'}" @click="setTheme('pink')"></span>
                    <span class="bg3" :class="{active:bg == 'green'}" @click="setTheme('green')"></span>
                    <span class="bg4" :class="{active:bg == 'silvery'}" @click="setTheme('silvery')"></span>
                    <span class="bg5" :class="{active:bg == 'black'}" @click="setTheme('black')"></span>
                </div>
                <div class="fr">
                    <span @click="setFont(1)">A-</span>
                    <span @click="setFont(2)">A+</span>
                </div>
            </div>
            <h3>{{curr.title}}</h3>

            <div class="chap" :class="fontsize" v-if="ischapter" v-html="decontent">

            </div>

            <div class="login" v-if="islogin">
                <router-link :to="{name:'Login',query:{cburl:this.$route.path}}">登陆阅读</router-link>
                <p>温馨提示：本章为VIP章节，需要登陆后阅读</p>
            </div>

            <div class="dingyue" @click.stop v-if="isdingyue">
                <h5>
                    <hr>
                    支持作家原创，支持正版阅读
                    <hr>
                </h5>
                <p class="tip1">如果您充值后依然无法继续阅读，由于网络原因书币到账会存在延迟，您可以尝试点我 <button class="reload" @click="getChapterInfo">刷新页面</button></p>
                <p class="tip1">如果依然无效，请添加我们客服微信：glg318</p>

                <p>账户余额：<span>{{getUserInfo.money}}</span> 书币，<span>{{getUserInfo.voucher}}</span> 书豆</p>
                <!--<div v-if="(curr.single == 1 && getUserInfo.money < curr.dz && getUserInfo.voucher < curr.dz) || (curr.whole == 1 && getUserInfo.money < curr.price && getUserInfo.voucher < curr.price)">-->
                    <!--<router-link to="/recharge" >充值</router-link>-->
                    <!--<p v-if="curr.single == 1 ">订阅本章需要 <span>{{curr.dz}}</span> 书币/书豆</p>-->
                <!--</div>-->

                <div class="dybox">
                    <div>
                        <!--<button v-if="curr.single == 1" @click="doDingyue">点此继续阅读精彩故事！</button>-->
                        <button v-if="curr.whole == 1" @click="doAll">点此继续阅读精彩故事！</button>
                        <router-link tag="button" to="/recharge" v-else>立即充值</router-link>
                    </div>
                    <p v-if="curr.single == 1">订阅本章需要{{curr.dz}}书币</p>
                    <p v-if="curr.whole == 1">订阅全本{{curr.price}}书币</p>
                    <!--<p v-if="curr.single == 1"><input type="checkbox" v-model="auto" checked="checked" /> 以后不用提醒我 自动订阅下一章</p>-->
                </div>


            </div>

            <div class="catalog" v-if="ischapter" @click.stop>
                <router-link tag="span" v-show="prev.id" replace :to="{name:'Chapter',params:{wid:bookid,cid:prev.id}}">上一章</router-link>
                <router-link tag="span" :to="{name:'Catalog',params:{wid:$route.params.wid}}">目录</router-link>
                <router-link tag="span" v-show="next.id" replace class="active" :to="{name:'Chapter',params:{wid:bookid,cid:next.id}}">下一章</router-link>
                <router-link tag="span" v-show="!next.id" class="active" :to="{name:'Empty',params:{sex:bookInfo.sex,wid:bookid},query:{finish:bookInfo.is_finish,sex:bookInfo.sex}}">下一章</router-link>
            </div>
            <!--<div class="guanzhu" v-if="ischapter && !collection">-->
            <!--点击右方【+关注】按钮，下次阅读更便捷-->
            <!--<span @click="doCollection">+ 关注</span>-->
            <!--</div>-->

            <ul v-if="ischapter">
                <router-link :to="{name:'Book',params:{wid:item.wid}}" v-for="item in intellect" tag="li" v-if="isvip">
                    <p>{{item.sort_description}}</p>
                </router-link>
                <router-link :to="item.link" v-for="item in recommend" tag="li">
                    <p>{{item.sort_description}}</p>
                </router-link>
                <!--<router-link :to="{name:'Book',params:{wid:item.wid}}" v-for="item in getTagsBook" tag="li">-->
                <!--<p>{{item.sort_description}}</p>-->
                <!--</router-link>-->


            </ul>

        </div>

        <div class="hidetool" v-show="hidetool" @click="hidetool = false">
            <div class="head" @click.stop>
                <router-link tag="span" :to="{name:'Book',params:{wid:$route.params.wid}}"><i class="el-icon-arrow-left"></i></router-link>
                <router-link tag="span" to="/" class="tc">首页</router-link>
                <router-link tag="span" :to="{name:'Reply',params:{wid:$route.params.wid}}" class="tr"><i class="el-icon-chat-dot-square"></i></router-link>
            </div>
            <div class="theme-box" @click.stop v-show="toolbox">
                <p class="color">
                    <label>主题</label>
                    <span class="bg1" :class="{active:bg == 'default'}" @click="setTheme('default')"></span>
                    <span class="bg2" :class="{active:bg == 'pink'}" @click="setTheme('pink')"></span>
                    <span class="bg3" :class="{active:bg == 'green'}" @click="setTheme('green')"></span>
                    <span class="bg4" :class="{active:bg == 'silvery'}" @click="setTheme('silvery')"></span>
                    <span class="bg5" :class="{active:bg == 'black'}" @click="setTheme('black')"></span>
                </p>
                <p class="font">
                    <label>字号</label>
                    <span @click="setFont(1)">A-</span>
                    <span @click="setFont(2)">A+</span>
                </p>
            </div>
            <div class="foot" @click.stop>
                <router-link tag="span" :to="{name:'Catalog',params:{wid:$route.params.wid}}">
                    <i class="el-icon-notebook-2"></i>
                    目录
                </router-link>
                <span @click="toolbox = !toolbox" :class="{active:toolbox}">
                    <i class="el-icon-setting"></i>
                    设置
                </span>
                <span @click="doaward">
                    <i class="el-icon-present"></i>
                    捧场
                </span>
                <router-link tag="span" to="/recharge">
                    <i class="el-icon-goods"></i>
                    充值
                </router-link>
                <span :class="{active : collection}" @click="doCollection">
                    <i class="el-icon-star-off"></i>
                    追书
                </span>

            </div>
        </div>
        <transition name="custom-classes-transition" enter-active-class="animated bounceInLeft" leave-active-class="animated bounceOutLeft">
            <div class="cataloghide" v-show="catalog" @click="catalog = false">
                <h3 @click.stop>目录
                    <span>共{{chapterTotal}}章</span>
                    <span class="fr" v-if="order == 1" @click="doOrder(0)">正序 <i class="el-icon-arrow-down"></i></span>
                    <span class="fr" v-if="order == 0" @click="doOrder(1)">倒序 <i class="el-icon-arrow-up"></i></span>
                </h3>
                <ul @click.stop  v-infinite-scroll="getCatalogList" infinite-scroll-immediate=false>
                    <li tag="li" @click="catalogBtn(item.id)" v-for="item in chapterList">
                        {{item.title}}
                        <span v-show="item.isvip == 1 && cps == 1">VIP</span>
                        <span v-show="item.cps_vip == 1 && cps > 1">VIP</span>
                    </li>
                </ul>
            </div>
        </transition>

        <div class="award-box" v-if="getUserInfo && getUserInfo.id > 0" v-show="award" @click="reward">
            <div class="award" @click.stop>
                <h4>为幸苦的作者大大打call～</h4>
                <ul>
                    <li :class="{active:rewardActive == 1}" @click="rewardActive = 1;rewardNum = 188"><a>188书币</a></li>
                    <li :class="{active:rewardActive == 2}" @click="rewardActive = 2;rewardNum = 588"><a>588书币</a></li>
                    <li :class="{active:rewardActive == 3}" @click="rewardActive = 3;rewardNum = 1000"><a>1000书币</a></li>
                    <li :class="{active:rewardActive == 4}" @click="rewardActive = 4;rewardNum = 5000"><a>5000书币</a></li>
                    <li :class="{active:rewardActive == 5}" @click="rewardActive = 5;rewardNum = 10000"><a>10000书币</a></li>
                    <li :class="{active:rewardActive == 6}" @click="rewardActive = 6"><a>其他金额 <input type="number" v-model="rewardNum"> 书币</a></li>
                </ul>
                <div class="footer">
                    <div class="fl">
                        余额：<span class="red">{{getUserInfo.money}}</span> 书币 <span class="red">{{getUserInfo.voucher}}</span> 书豆
                    </div>
                    <div class="fr">
                        <span v-show="getUserInfo.money >= rewardNum" @click="doReward">打赏</span>
                        <router-link to="/recharge" v-show="getUserInfo.money < rewardNum">充值</router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="tousu" v-if="tousu">
            <p class="head-btn">
                <i class="el-icon-close" @click="tousu = 0"></i> 投诉
            </p>

            <p class="title">请选择投诉原因</p>
            <ul>
                <li :class="{active : ts.active == 1}" @click="ts.active = 1">色情低俗</li>
                <li :class="{active : ts.active == 2}" @click="ts.active = 2">政治敏感</li>
                <li :class="{active : ts.active == 3}" @click="ts.active = 3">违法犯罪</li>
                <li :class="{active : ts.active == 4}" @click="ts.active = 4">广告骚扰</li>
                <li :class="{active : ts.active == 5}" @click="ts.active = 5">无法继续阅读</li>
                <li :class="{active : ts.active == 6}" @click="ts.active = 6">标题或封面图片低俗</li>
                <li :class="{active : ts.active == 7}" @click="ts.active = 7">其他</li>
            </ul>
            <p class="title">投诉原因描述</p>
            <el-input v-model="ts.intro" placeholder="请输入投诉内容(选填)" maxlength="100" show-word-limit></el-input>
            <p class="title">请留下您的联系方式，方便我们核实情况</p>
            <el-input v-model="ts.phone" placeholder="请输入您的手机号码(选填)"></el-input>
            <p style="text-align: center">
                <el-button type="primary" @click="complaint">确定提交</el-button>
            </p>
        </div>
        <transition name="custom-classes-transition" enter-active-class="animated bounceInDown" leave-active-class="animated bounceOutUp">

            <div  class="special" v-show="special" @click="special=false">
                <div class="xian-box">
                    <span class="xian"></span>
                    <span class="dian"></span>
                </div>
                <router-link tag="div" class="book" :to="{name:'Book',params:{wid:specialInfo.bookid}}">
                    <img :src="specialInfo.cover" alt="">
                    <p class="tl">{{specialInfo.title}}</p>
                    <p class="tr">{{specialInfo.author}}</p>
                </router-link>

            </div>
        </transition>

        <transition name="custom-classes-transition" enter-active-class="animated bounceInDown" leave-active-class="animated bounceOutUp">
            <div  class="force" v-show="force" @click="force = 0">
                <div class="box">
                    <p class="tw">
                        防止书币，阅读记录丢失～！<br>
                        请长按下方二维码识别进入书城
                    </p>
                    <h4>长按识别二维码免费阅读本书～</h4>
                    <img  :src="'https://open.weixin.qq.com/qr/code?username=' + wechatName" alt="">

                    <h5>
                        提醒：保存图片至相册可用<br>
                        微信扫一扫识别进入
                    </h5>
                </div>
                <div class="close" @click="force = 0">
                    <span class="iconfont icon-times"></span>
                </div>
            </div>
        </transition>
        <transition name="custom-classes-transition" enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div  class="backList" v-show="isBack">

                <div class="list">
                    <div class="close" @click="closeBack">
                        <span class="iconfont icon-times"></span>
                    </div>
                    <img src="http://static.yuread.cn/upload/cps/back.png" alt="" class="back_img">
                    <ul>
                        <router-link :to="{name:'Book',params:{wid:item.wid}}" v-for="item in backList" tag="li">
                            <img :src="'http://static.yuread.cn/' + item.h_cover" alt="">
                            <div class="back_info">
                                <h3>{{item.title}}</h3>
                                <p class="star">推荐指数：
                                    <i class="iconfont icon-collection-fill"></i>
                                    <i class="iconfont icon-collection-fill"></i>
                                    <i class="iconfont icon-collection-fill"></i>
                                    <i class="iconfont icon-collection-fill"></i>
                                    <i class="iconfont icon-collection-fill"></i>
                                </p>
                                <p class="description">{{item.sort_description}}</p>
                            </div>
                        </router-link>
                    </ul>
                </div>

            </div>
        </transition>
    </div>
</template>

<script>
    import CryptoJS from 'crypto-js';
    import Swal from 'sweetalert2';
    export default {
        name: "Chapter",
        data(){
            return {
                getUserInfo: {
                        id: this.$store.getters.getUserInfo.id, 
                        money:this.$store.getters.getUserInfo.money,
                        voucher: this.$store.getters.getUserInfo.voucher
                },
                bookInfo : {},
                bookid:this.$route.params.wid,
                chapterid : this.$route.params.cid,
                bg :'default',
                hidetool : false,
                toolbox : false,
                fontsize : 'fontsize42',
                fontnum : 42,
                catalog:false,
                rewardActive : 1,
                award : false,
                rewardNum : 188,
                ischapter : false,
                islogin : false,
                isdingyue : false,
                prev:{},
                curr:{},
                next:{},
                auto : true,

                order : 1,
                page : 1,
                chapterLoad:true,
                limit : 20,
                chapterList : [],
                chapterTotal : 0,
                isLoadChapter : false,//是否加载过章节

                collection : 0,
                recommend : [],
                intellect : [],
                tagsRecommend : [],
                cunzai : [],
                src:'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
                cps : 1,
                tousu : 0,
                ts : {
                    active : 0,
                    intro : '',
                    phone : ''
                },
                special : false,
                specialInfo : {
                    bookid : '',
                    cover : '',
                    title : '',
                    author : ''
                },
                isvip : 0,
                issign : false,
                force : 0,
                wechatName : '',
                isBack : false,
                backList : [],
            }
        },
        computed:{
            getUserInfo(){
                return this.$store.getters.getUserInfo;
            },
            decontent(){
                let code = '9de40a1f37bafc726bfe9ef6d2041665';
                let iv = CryptoJS.enc.Utf8.parse(code.substring(0,16));
                let key = CryptoJS.enc.Utf8.parse(code.substring(16));
                return CryptoJS.AES.decrypt(this.curr.content,key,{iv:iv,padding:CryptoJS.pad.Pkcs7}).toString(CryptoJS.enc.Utf8);
            },
            getRecommend(){
                let recommend = [];
                this.recommend.forEach(v =>{
                    if(v.sex == this.bookInfo.sex){
                        recommend.push(v);
                    }
                })
                return recommend;
            },
            getTagsBook(){
                let books = [];
                this.tagsRecommend.forEach(v => {
                    if(this.cunzai.indexOf(v.wid) > -1){

                    }else{
                        books.push(v)
                    }
                })
                return books;
            }

        },
        watch : {
            '$route'(to,from){
                if(to.path != from.path){
                    this.getChapterInfo();
                    this.ischapter = false;
                    this.islogin = false;
                    this.isdingyue = false;
                }
            }
        },
        methods:{
            catalogBtn(chapterid){
                this.catalog = false;
                this.$router.push({name:'Chapter',params:{wid:this.bookid,cid:chapterid}})
            },
            setTheme(bg){
                localStorage.setItem('theme-bg',bg);
                this.bg = bg;
            },
            resetUserInfo(){
                this.axios.post('/api/user/getUserInfo').then(r => {
                    let data = r.data;
                    console.log(data.data);
                    if(data.code == 1){
                        this.$store.dispatch('setUserInfo',data.data);
                    }
                })
            },
            setFont(type){

                if(type ==1){
                    if(this.fontnum <=30){
                        this.fontnum = 30;
                        this.fontsize = 'fontsize30';
                    }else{
                        this.fontnum -= 4;
                        this.fontsize = 'fontsize' + this.fontnum;
                    }
                }else{
                    if(this.fontnum >= 46){
                        this.fontnum = 46;
                        this.fontsize = 'fontsize46';
                    }else{
                        this.fontnum += 4;
                        this.fontsize = 'fontsize' + this.fontnum;
                    }
                }
                localStorage.setItem('font-size',this.fontnum);
            },
            setCatalog(){
                if(!this.isLoadChapter){
                    this.getCatalogList();
                    this.isLoadChapter = true;
                }
                this.catalog = true;

            },
            reward(){
                this.award = false;
            },
            doaward(){
                if(this.getUserInfo.id > 0){
                    this.hidetool = false;
                    this.award = true;
                }else{
                    if(confirm("请先登录后操作！")){
                        this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    }
                }
            },
            doReward(){
                this.axios.post("/api/reward/doReward",{
                    money : this.rewardNum,
                    bid : this.$route.params.wid,
                }).then(r => {
                    let data = r.data;
                    if(data.code == 0){
                        this.$message.error(data.msg);
                    }else if(data.code == 1){
                        this.award = false;
                        this.$message.success(data.msg);
                        //存储用户信息
                        this.$store.dispatch('setUserInfo',data.data);
                    }
                });
            },

            getChapterInfo(){
                let loading = this.$loading({
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.isdingyue = false;
                this.axios.post('/api/chapter/chapter',{
                    bookid : this.$route.params.wid,
                    chapterid : this.$route.params.cid,
                }).then(r => {
                    loading.close();
                    console.log('zzzzz');
                    if(this.getUserInfo && this.getUserInfo.id > 0){
                            this.signIn();
                    }
                    console.log('dddddd');
                    let data = r.data;
                    console.log('ccccccc');
                    console.log(data);
                    if(this.$route.params.wid == 45903 && this.$route.params.cid == 1706578 && data.data.liedengjiyin == 0){
                    Swal.fire({
                        title: '',
                        text: '本书《劣等基因》为一次性购买，需要花费1999书币，请知悉！',
                        icon: 'info',
                        confirmButtonText: '确定'
                      });
                    }
                    if(data.code == 0){
                        // this.islogin = true;
                        this.$router.push({name:'Login',query:{cburl:this.$route.path}})
                    }else if(data.code == 2){
                        this.$router.push('/follow/'+this.bookid+"/"+this.$route.params.cid)
                    }else if(data.code == 3){
                        this.$message.error(data.msg);
                        this.$router.go(-1);
                    }else if(data.code == 1){
                        this.$store.dispatch('setUserInfo',data.data.userinfo);
                        this.bookInfo = data.data.bookInfo;
                        this.collection = data.data.collection;
                        let intellect = data.data.intellect;
                        this.force = data.data.force;
                        this.wechatName = data.data.wechatName;
                        this.backList = data.data.backRecommend;
                        if(intellect){
                            this.intellect = intellect;
                            this.intellect.forEach(v =>{
                                this.cunzai.push(v.wid);
                            })
                        }
                        if(this.recommend.length <1){
                            let recommend = data.data.recommend;
                            if(recommend){
                                recommend.forEach(v => {
                                    this.cunzai.push(v.bookid)
                                    if(v.sex == this.bookInfo.sex){
                                        this.recommend.push(v);
                                    }
                                })

                            }
                        }

                        // let tagsRecommend = data.data.tagsRecommend;
                        // if(tagsRecommend){
                        //     this.tagsRecommend = tagsRecommend;
                        // }
                        if(data.data.chapterInfo.code == 1){
                            this.ischapter = true;
                            this.curr = data.data.chapterInfo.data.curr;
                            this.prev = data.data.chapterInfo.data.prev;
                            this.next = data.data.chapterInfo.data.next;
                            this.isvip = data.data.chapterInfo.data.vip;
                            if(data.data.chapterInfo.userinfo){
                                //this.$store.dispatch('setUserInfo',data.data.chapterInfo.userinfo);
                            }
                            this.$refs['chapter'].scrollTop = 0;
                        }else if(data.data.chapterInfo.code == 4){
                            this.isdingyue = true;
                            this.curr = data.data.chapterInfo.data.curr;
                            this.prev = data.data.chapterInfo.data.prev;
                            this.next = data.data.chapterInfo.data.next;
                        }else if(data.data.chapterInfo.code == 6){
                            this.$message.error(data.data.chapterInfo.msg);
                            this.$router.go(-1);
                        }else if(data.data.chapterInfo.code == 5){
                            this.$message.error(data.data.chapterInfo.msg);
                            this.isdingyue = true;
                            this.curr = data.data.chapterInfo.data.curr;
                            this.prev = data.data.chapterInfo.data.prev;
                            this.next = data.data.chapterInfo.data.next;
                            //不能打开否则充值时，用户不充值 无法返回
                            // this.$router.push('/recharge');
                        }

                    }

                }).catch(res => {
                    loading.close();
                });
            },
            doDingyue(){
                let loading = this.$loading({
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.axios.post('/api/chapter/doDingyue',{
                    bookid : this.$route.params.wid,
                    chapterid : this.$route.params.cid,
                    auto : this.auto

                }).then(r => {
                    loading.close();
                    let data = r.data;
                    if(data.code == 1){
                        this.ischapter = true;
                        this.isdingyue = false;
                        this.$store.dispatch('setUserInfo',data.userinfo);

                        document.getElementById('chapter').scrollTop=0;
                    }else{
                        this.$message.error(data.msg);
                        this.$router.push('/recharge');
                    }
                })
            },
            doAll(){
                let loading = this.$loading();
                this.axios.post('/api/chapter/doAll',{
                    bookid : this.$route.params.wid,
                }).then(r => {
                    loading.close();
                    let data = r.data;
                    if(data.code == 1){
                        this.ischapter = true;
                        this.isdingyue = false;
                        this.$store.dispatch('setUserInfo',data.userinfo);
                    }else{
                        this.$message.error(data.msg);
                        this.$router.push('/recharge');
                    }
                })
            },
            getCatalogList(){
                if(!this.chapterLoad){
                    return;
                }
                this.chapterLoad = false;

                this.axios.post('/api/catalog/getCatalogList',{
                    page : this.page,
                    order : this.order,
                    limit : this.limit,
                    bid : this.bookid
                }).then(r => {
                    let data = r.data;
                    if(data.code){
                        data.data.forEach(v => {
                            this.chapterList.push(v)
                        })
                        this.page ++;
                        this.chapterLoad = true;
                        this.chapterTotal = data.total;
                        this.cps = data.cps;
                    }else{
                        this.$message.error(data.msg);
                    }

                })
            },
            doOrder(order){
                this.order = order;
                this.page = 1;
                this.chapterList = [];
                this.getCatalogList();
            },
            getCollection(){
                this.axios.post('/api/collection/getCollection',{
                    bookid:this.bookid
                }).then(r => {
                    this.collection = r.data.code;
                })
            },
            doCollection(){
                if(this.getUserInfo.id > 0){
                    this.axios.post('/api/collection/doCollection',{
                        bid : this.bookid,
                        type : this.collection ? 0 : 1,
                    }).then(r =>{
                        let data = r.data;
                        if(data.code == 1){
                            this.collection = this.collection ? 0 : 1;
                        }
                    })
                }else{
                    if(confirm("请先登录后操作！")){
                        this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    }
                }
            },

            signIn(){
                if(this.issign){
                    return;
                }
                if(this.getUserInfo.id){
                    this.axios.post('/api/user/signIn').then(r => {
                        this.issign = true;
                        if(r.data.code){
                            this.$message.success(r.data.msg);
                        }
                    })
                }

            },
            complaint (){
                this.axios.post('/api/chapter/complaint',{
                    bookid:this.$route.params.wid,
                    chapterid : this.$route.params.cid,
                    active : this.ts.active,
                    intro : this.ts.intro,
                    phone : this.ts.phone
                }).then (r => {
                    this.tousu = 0;
                    alert("您的投诉已提交！")
                })
            },

            getSpecial(){
                let hour = new Date().getHours();
                if(hour >= 18){
                    return;
                }
                let user = this.getUserInfo;
                if(user.id > 0){
                    this.axios.post('/api/recommend/getSpecial',{
                        bookid : this.$route.params.wid
                    }).then(r => {
                        if(r.data.code){
                            this.specialInfo.cover = 'http://static.yuread.cn/' + r.data.data.h_cover;
                            this.specialInfo.bookid = r.data.data.wid;
                            this.specialInfo.title = r.data.data.title;
                            this.specialInfo.author = r.data.data.author;
                            this.special = true;
                        }
                    })
                }
            },

            closeBack(){
                this.isBack = false;
                window.nextObj();
            }

        },
        mounted(){
            window.addEventListener('pageshow', function(e) {
            // 通过persisted属性判断是否存在 BF Cache
                if (e.persisted) {
                    location.reload();
                }
            });
        },
        created(){
            this.resetUserInfo();
            let book = ['38564','38938'];

            if(document.body.clientWidth > 750 && book.indexOf(this.$route.params.wid) > -1){
                this.$router.push({name:'Tiaozhuan',params:{wid:this.$route.params.wid}});
                return ;
            }


            let size = localStorage.getItem('font-size');
            if(size){
                this.fontnum = parseInt(size);
                this.fontsize = 'fontsize' + size;
            }
            let bg = localStorage.getItem('theme-bg');
            if(bg){
                this.bg = bg;
            }
            this.getChapterInfo();
            this.getSpecial();
        },

        beforeRouteLeave(to,form,next){

            window.nextObj = next;
            let name = to.name;
            if(name == 'Book' ){
                let wid = parseInt(to.params.wid);
                if(this.cunzai.indexOf(wid) > -1){
                    next();
                }
            }

            if(['Login','Keep'].indexOf(name) > -1 ){
                this.$router.replace('/');
                return ;
            }

            if(['Index','Book'].indexOf(name) > -1){

                if(!this.isBack){
                    this.isBack = true;
                    next(false);
                }else{
                    this.isBack = false;
                    next();
                }
            }else{
                next();
            }


        }
    }
</script>

<style lang="less">
    @import "~animate.css";
    #chapter{height: 100%;overflow: auto;-webkit-overflow-scrolling: touch;
        .tip1{color: #867964;}
        .head-tool{padding: 26px 20px;position: fixed;top:0;width:100%;color: #746A58;
            .title{width: 350px;display: inline-block;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;}
            span{font-size: 28px;color:#333;
                i{font-size: 30px;}
            }
            .fr{margin-left: 30px;}
            .tousu-btn{color:red;font-size: 28px;font-weight: 500;
                i{font-weight: bold;}
            }
        }
        .info{padding-top: 100px;min-height: 1600px;
            .tool{overflow: hidden;margin-bottom: 20px;
                .fl{
                    span{width: 44px;height:44px;border:1px solid #999;display: inline-block;border-radius: 50%;margin-left: 20px;}
                    span.active{border: 1px solid @theme;}
                    .bg1{background: #c4b397;}
                    .bg2{background: #f9f0df;}
                    .bg3{background: #d1edd1;}
                    .bg4{background: #e6e6e6;}
                    .bg5{background: #2c2c2c;}
                }
                .fr{
                    span{width: 44px;height:44px;font-size:26px;line-height:44px;text-align:center;border:1px solid #999;display: inline-block;border-radius: 50%;margin-right: 20px;color: #999;}

                }
            }
            h3{font-size: 52px;font-weight: 400;text-indent: 20px;}
            .chap{padding: 30px;min-height: 1000px;
                p{padding-bottom: 30px;color: #1D1B16;}
            }
            .login{padding:30px 0 100px;
                a{
                    width: 90%;height:100px;text-align:center;line-height:100px;background: @theme;display: block;margin: 0 auto;border:none;border-radius: 10px;color:#fff;font-size: 36px;
                }
                p{text-align: center;font-size: 30px;color:#867964;line-height: 50px;}
            }

            .dingyue{padding:30px 0 100px;text-align: center;
                a{ width: 90%;height:100px;text-align:center;line-height:100px;background: @theme;display: block;margin: 0 auto;border:none;border-radius: 10px;color:#fff;font-size: 36px;}
                h5{color:#867964;line-height: 100px;font-size: 30px;
                    hr{width: 36px;display: inline-block;vertical-align: middle;border: none;border-bottom: 1px solid #756247;margin: 0 10px;}
                }

                p{font-size: 26px;line-height: 80px;
                    span{color: @theme;font-weight: bold;}
                }
                .dybox{padding:30px;
                    >div{display: flex;
                        button{flex: 1;background: red;height:90px;border:none;border-radius: 8px;color:#fff;font-size: 30px;margin: 0 20px;}

                    }


                }

            }

            .fontsize34{
                p{
                    font-size: 34px;line-height: 60px;
                }
            }
            .fontsize30{
                p{
                    font-size: 30px;line-height: 56px;
                }
            }
            .fontsize38{
                p{
                    font-size: 38px;line-height: 64px;
                }
            }
            .fontsize42{
                p{
                    font-size: 42px;line-height: 68px;
                }
            }
            .fontsize46{
                p{
                    font-size: 46px;line-height: 72px;
                }
            }
            .shang{display: block;background: @theme;border:none;width: 160px;height:160px;margin: 0 auto;border-radius: 50%;color:#fff;font-size: 50px;}

            .catalog{display: flex;padding: 30px 0;
                span{flex:1;text-align: center;padding: 10px 0;border-radius: 40px;font-size: 30px;border:1px solid @theme;color: @theme;margin:0 30px;}
                .active{background: @theme;color:#fff;}
            }
            .guanzhu{height:80px;width:90%;margin: 0 auto;background: #cec2af;font-size: 24px;line-height: 80px;color:#33373d;padding-left: 10px;
                span{float: right;background: #1ead16;padding: 0 40px;color:#fff;}
            }

            ul{padding: 20px;margin-bottom: 50px;
                li{padding: 20px 0;border-bottom:1px solid #666;overflow: auto;
                    p{font-size: 30px;color: #666;overflow: hidden;text-overflow:ellipsis; white-space: nowrap;}

                }
            }
            .ttt{font-size: 36px;padding-left: 20px;}
            .reload{background: @theme;border-radius: 4px;border:0;color: #fff;padding: 4px 6px;}
        }

        .hidetool{
            position: fixed;top:0;left:0;right:0;bottom:0;z-index: 999;
            .head {display: flex;padding: 26px 20px;background: rgba(0,0,0,.5);
                span{flex:1;font-size: 30px;color:#333;color: #fff;
                    i{font-size: 40px;}
                }
            }
            .theme-box{position:absolute;bottom: 100px;width:100%;background: rgba(0,0,0,.5);color:#fff;border:1px solid rgba(255,255,255,.2);
                p{overflow: auto;
                    label{width:100px;height:80px;line-height:80px;display: block;text-align: center;font-size: 26px;float: left;}
                }
                .color{padding: 20px 0;
                    span{width:80px;height: 80px;display: block;float:left;margin-right: 30px;border-radius: 50%;}
                    span.active{border: 1px solid @theme;}
                    .bg1{background: #c4b397;}
                    .bg2{background: #f9f0df;}
                    .bg3{background: #d1edd1;}
                    .bg4{background: #e6e6e6;}
                    .bg5{background: #2c2c2c;}
                }
                .font{
                    padding: 20px 0;
                    span{width:280px;height: 80px;display: block;float: left;background:#fff;line-height: 80px;text-align: center;margin-right: 20px;color:#ABB1B3;border-radius: 80px;font-size: 30px;}
                }

            }
            .foot{position:absolute;bottom:0;width:100%;display: flex;background: rgba(0,0,0,.5);color: #fff;height: 100px;
                span{flex:1;text-align: center;font-size: 26px;padding-top: 16px;
                    i{display: block;font-size: 36px;}
                }
                span.active{
                    color: @theme;
                }

            }
        }
        .cataloghide{position:fixed;top:0;left:0;right:0px;bottom:0px;z-index: 999;
            h3{border-bottom: 1px solid @theme;
                width:80%;background: #fff;font-size: 32px;color:@theme;font-weight: 400;padding: 20px;
                span{font-size: 28px;color: #6e6e6e;}
                .fr{color:#a6a6a6;}
            }
            ul{
                background: #fff;width: 80%;height: calc(100% - 86px);overflow: auto;
                li{
                    padding:20px;font-size: 30px;color:#201E18;border-bottom: 1px solid #efefef;
                    span{background: @theme;color: #fff;padding: 2px 10px; font-size: 24px;float: right;border-radius: 8px;}
                }
            }

        }
        .award-box{
            position:fixed;top:0;left:0;right: 0;bottom: 0;z-index: 999;
            .award{width:100%;position: absolute;bottom: 0;background: #fff;
                h4{color:@theme;font-size: 24px;padding: 20px;border-bottom: 1px solid #efefef;}
                ul{padding: 20px 10px;overflow: hidden;
                    li{float: left;width:50%;padding: 0 10px;text-align: center;margin-bottom: 20px;
                        a{border:1px solid #efefef;width:100%;display: inline-block;padding: 20px;border-radius: 10px;font-size: 24px;color:#666;
                            input{width:80px;border:none;border-bottom:1px solid #efefef;}
                            input{width:80px;border:none;border-bottom:1px solid #efefef;}
                        }
                    }
                    li.active{
                        a{
                            border:1px solid @theme;color: @theme;
                        }
                    }
                }
                .footer{overflow: hidden;border-top:1px solid #efefef;height: 100px;line-height: 100px;
                    .fl{font-size: 24px;color:#666;padding-left: 20px;}
                    .red{color:@theme;}
                    .fr{width: 200px;background: @theme;height: 100%;text-align: center;color:#fff;font-size: 24px;
                        a{color: #fff;}
                    }
                }

            }
        }
        .tousu{
            position: fixed;top: 0;bottom: 0;width: 100%;z-index: 999999;background: #ededed;
            .head-btn{background: #ededed;color: #666;font-weight:500;line-height: 80px;text-indent: 10px;font-size: 30px;border-bottom: 1px solid #e6e3e3;}

            .title{background: #ededed;color: #9e9e9e;line-height: 80px;text-indent: 20px;}
            ul{padding: 0 20px;background: #fff;
                li{height: 80px;line-height: 80px;border-bottom: 1px solid #efefef;color: #666;font-size: 30px;}
                .active{color: #409eff}
            }
            input{height: 80px;line-height: 80px;font-size: 30px;border: none;}
            .el-input__count-inner{font-size: 20px;}
            button{background: #409eff;border:none;height: 80px;margin-top: 20px;width: 80%;font-size: 30px;}
        }
        .special{position:fixed;top: 0;left: 0;right:0;bottom:0;z-index: 999;

            .xian-box{height: 310px;
                .xian{background:#ededed;display: block;margin:0 auto;height: 300px;width: 8px;z-index: 9999;position: relative;border-radius: 0 0 20px 20px;box-shadow: 3px 3px 3px #666;}
                .dian{background: #999;display: block;margin:0 auto;height: 20px;width: 20px;border-radius: 50%;z-index: 9991;position:relative;top:-10px;}
            }

            .book{width: 400px;height: 600px;margin:-30px auto;text-align: center;border-radius: 20px;overflow: hidden;background: #fff;box-shadow: 5px 5px 10px #000;
                img{width: 100%;height: 500px;display: block;}
                p{color: #666;font-size: 30px;padding: 10px 20px;line-height: 30px;}
                .tr{font-size: 24px;color: #999}

            }
        }

        .force{position:fixed;top: 0;left: 0;right:0;bottom:0;z-index: 998;background-color: rgba(0,0,0,.5);
            .box{width: 610px;height: 850px;background-image: url("http://static.yuread.cn/upload/cps/bg.png");background-size: 100% ;margin:200px auto 0;text-align: center;padding-top: 200px;
                .tw{font-size: 32px;color: #fff;}
                h4{margin:60px 0 20px;font-size: 28px;color: #000;}
                img{width: 288px;height: 288px;}
                h5{font-size: 28px;margin: 20px 0 0 0;color: #000;}
            }
            .close{text-align: center;margin-top: 100px;color: #fff;
                span{border: 5px solid #fff;border-radius: 50%;}
            }

        }

        .backList{position:fixed;top: 0;left: 0;right:0;bottom:0;z-index: 998;background-color: rgba(0,0,0,.5);
            .list{position:absolute;bottom:0;background-color: #fff;border-radius: 40px 40px 0 0 ;
                .back_img{width: 100%;}
                ul{margin-top: -50px;height: 762px;overflow: auto;
                    li{padding:0 40px 40px;overflow: auto;
                        img{width: 164px;height:214px;border-radius: 6px;float: left;}
                        .back_info{float: right;width: 466px;
                            h3{color: #313133;font-size: 30px;margin-top:20px;}
                            .star{color: #ABABAB;font-size: 24px;margin:10px 0;
                                i{color: #F76B1C;margin-right: 6px;}
                            }
                            .description{height:70px;color: #808080;font-size: 26px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;}

                        }
                    }
                }
                .close{position:absolute;top:30px;right:30px;}
            }
        }
    }


    #chapter.default{
        background: url("./../assets/images/1.jpg");background-repeat:repeat-y;background-size: 100%;
        .head-tool{background: url("./../assets/images/1.jpg");background-repeat:repeat-y;background-size: 100%;}
    }
    #chapter.pink{
        background: url("./../assets/images/2.jpg");background-repeat:repeat-y;background-size: 100%;
        .head-tool{background: url("./../assets/images/2.jpg");background-repeat:repeat-y;background-size: 100%;}
    }
    #chapter.silvery{
        background: url("./../assets/images/3.jpg");background-repeat:repeat-y;background-size: 100%;
        .head-tool{background: url("./../assets/images/3.jpg");background-repeat:repeat-y;background-size: 100%;}
    }
    #chapter.green{
        background: #D1EDD1;
        .head-tool{background: #D1EDD1;}
    }
    #chapter.black{

        background: #2c2c2c;
        h3{color: #A9A9A9;}
        .chap{
            p{color: #A9A9A9;}
        }
        .head-tool{background: #2c2c2c;
            span{color: #A9A9A9}
        }
        ul{
            li{
                .fr{color: #A9A9A9}

            }
        }
    }
</style>
